export interface EditProfileDto
{
    getClientTxnId(): string;
    getIdentifier(): string;
    getLanguage(): string;
    getMsisdn(): string;
    getServType(): string;
    getUpdatableServiceValue() : string; // name  or  categoryId  or  email  or  previewImage  or  dob
}

export class EditProfileDtoImpl implements EditProfileDto
{
    private clientTxnId: string;
    private identifier: string;
    private language: string;
    private msisdn: string;
    private servType: string;
    private updateableServiceValue: string;

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setIdentifier(identifier: string)
    {
        this.identifier = identifier;
    }
    getIdentifier(): string 
    {
        return this.identifier;
    } 

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    } 

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    } 

    setServType(servType: string)
    {
        this.servType = servType;
    }
    getServType(): string 
    {
        return this.servType;
    } 

    setUpdatableServiceValue(updateableServiceValue: string)
    {
        this.updateableServiceValue = updateableServiceValue;
    }
    getUpdatableServiceValue(): string 
    {
        return this.updateableServiceValue;
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/editprofile/editprofiledto.ts